import React, { Component } from 'reactn'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import { clearState } from '../../Services'

export default class AdminLayout extends Component {
  constructor (props) {
    super(props)
    this.state = { sidebarOpen: false }
  }

  async logout () {
    await this.setGlobal({ loggedIn: false })
    clearState()
    window.location.reload()
  }

  render () {
    const user = this.global.user

    return (
      <div className='admin-layout'>
        <Sidebar
          open={this.state.sidebarOpen}
          onClose={() => this.setState({ sidebarOpen: false })}
          onLogout={() => this.logout()}
          userType={user?.type}
        />
        <div style={{ flex: 1 }}>
          <Header
            title='Sanifrutta Admin'
            userName={user?.name}
            onToggleSidebar={() => this.setState({ sidebarOpen: !this.state.sidebarOpen })}
          />
          <main className='admin-content'>
            <Outlet />
          </main>
        </div>
      </div>
    )
  }
}
